import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Importar estilos do Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const PastorsSwiper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const pastorsData = [
    {
      id: 1,
      name: "Pr. Fábio Amorim",
      title: "Pastor Presidente",
      image: "/images/pr_fabio.png",
    },
    {
      id: 2,
      name: "Pr. Sérgio Pinheiro",
      title: "Pastor Vice-Presidente",
      image: "/images/pr_sergio.png",
    },
    {
      id: 3,
      name: "Pr. Guilermando Flor",
      title: "Pastor",
      image: "/images/pr_guilerme.png",
    },
    {
      id: 4,
      name: "Pr. Sílvio Costa",
      title: "Pastor",
      image: "/images/pr_silvio.png",
    },
    {
      id: 5,
      name: "Pr. Jefferson Nunes",
      title: "Pastor",
      image: "/images/pr_jefferson.png",
    },
    {
      id: 6,
      name: "Pr. Charles Perazzo",
      title: "Pastor",
      image: "/images/pr_charles.png",
    },
    {
      id: 7,
      name: "Pr. Felipe Diniz",
      title: "Pastor",
      image: "/images/pr_felipe.png",
    },
  ];

  const slidesPerView = isMobile ? 1 : isTablet ? 2 : 4;

  return (
    <Box sx={{ position: "relative" }}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={slidesPerView}
        navigation={{
          prevEl: ".pastors-swiper-button-prev",
          nextEl: ".pastors-swiper-button-next",
        }}
        pagination={{
          clickable: true,
          el: ".pastors-swiper-pagination",
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        speed={800}
        style={{
          "--swiper-navigation-color": theme.palette.primary.main,
          "--swiper-pagination-color": theme.palette.primary.main,
          "--swiper-pagination-bullet-inactive-color":
            theme.palette.background.default,
          "--swiper-navigation-size": "24px",
        }}
      >
        {pastorsData.map((pastor) => (
          <SwiperSlide key={pastor.id}>
            <Card
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: 3,
                boxShadow: 3,
                background: theme.palette.primary.main,
                height: "280px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                },
              }}
            >
              {/* Foto do Pastor */}
              <Box
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  overflow: "hidden",
                  mb: 2,
                  border: "4px solid white",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}
              >
                <CardMedia
                  component="img"
                  height="120"
                  image={pastor.image}
                  alt={pastor.name}
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    objectPosition:
                      pastor.id === 2 ? "center 80%" : "center center",
                  }}
                />
              </Box>

              {/* Nome e Título */}
              <CardContent sx={{ textAlign: "center", p: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: "1rem", md: "1.1rem" },
                    mb: 0.5,
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  {pastor.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                    fontSize: { xs: "0.8rem", md: "0.9rem" },
                    opacity: 0.9,
                    textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                  }}
                >
                  {pastor.title}
                </Typography>
              </CardContent>

              {/* Efeito decorativo */}
              <Box
                sx={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  opacity: 0.6,
                }}
              />
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navegação Desktop */}
      {!isMobile && (
        <>
          <div
            className="pastors-swiper-button-prev"
            style={{
              position: "absolute",
              left: -40,
              top: "50%",
              transform: "translateY(-50%)",
              width: 40,
              height: 40,
              backgroundColor: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
              cursor: "pointer",
              zIndex: 10,
              color: theme.palette.primary.main,
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            ‹
          </div>
          <div
            className="pastors-swiper-button-next"
            style={{
              position: "absolute",
              right: -40,
              top: "50%",
              transform: "translateY(-50%)",
              width: 40,
              height: 40,
              backgroundColor: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
              cursor: "pointer",
              zIndex: 10,
              color: theme.palette.primary.main,
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            ›
          </div>
        </>
      )}

      {/* Paginação */}
      <div
        className="pastors-swiper-pagination"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
          gap: "4px",
        }}
      />
    </Box>
  );
};
